



























































import Vue from "vue";
import { PropOptions } from "vue/types/options";
import storeHelper from "../../store/store-helper";
import ConfirmationPromptCard from "../../components/generic/ConfirmationPromptCard.vue";
import router from "@/router";
import store from "@/store";
import { Team } from "@/teams";
import ZenyaDialog from "../../components/dialogs/ZenyaDialog.vue";
import { SnackBarTimeout } from "@/enums";

export default Vue.extend({
    name: "TeamProperties",
    components: {},
    props: {
        team: Object as () => Team
    },
    data: function () {
        return { name: "", description: "" };
    },
    created() {},
    mounted() {
        this.name = this.team.name;
        this.description = this.team.description;
    },
    watch: {
        team() {
            this.name = this.team.name;
            this.description = this.team.description;
        }
    },
    computed: {
        isManager(): boolean {
            return this.team.managers.findIndex(m => m.user_id === this.$user.user_id) > -1;
        }
    },
    methods: {
        async deleteTeamClicked() {
            const confirmed: boolean = await this.$confirm(
                this.$t(`teams.deleteTeamDialog`).toString(),
                this.$t("confirmationMessages.delete", { n: this.$t("teams.team").toString().toLocaleLowerCase() }).toString()
            );

            if (confirmed) {
                await this.deleteTeam();
                this.$router.push("/");
            }
        },
        required() {
            return v => !!v || `${this.$t("general.validation.isRequired")}`;
        },
        validateForm() {
            const formIsValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

            return formIsValid;
        },
        async saveChanges() {
            if (this.isManager && this.validateForm()) {
                if (this.name == this.team.name && this.description == this.team.description) {
                    return;
                }
                const updateTeamResult = await storeHelper.teamsStore.updateTeam(this.team.team_id, this.name, this.description);
                if (updateTeamResult.success)
                    storeHelper.siteStore.setSnackBarMessage(
                        this.$t("general.messages.changeWasSuccesfully").toString(),
                        false,
                        SnackBarTimeout.long
                    );
            }
        },
        async deleteTeam() {
            const deleteTeamResult = await storeHelper.teamsStore.deleteTeam(this.team.team_id);

            if (deleteTeamResult.success)
                storeHelper.siteStore.setSnackBarMessage(this.$t("teams.teamIsDeleted").toString(), false, SnackBarTimeout.long);
        }
    }
});
